import * as urlModule from 'url';
import * as qsModule from 'querystring';

import { RouteState, RouteParams } from './route-state';
import { RouteStateBuilder } from '@app/core/search/routing/route-state-builder';

export class UrlParser {
  private builder: RouteStateBuilder;

  constructor(url: string) {
    this.builder = new RouteStateBuilder(url);
    this.parse(url);
  }

  getRouteState(): RouteState {
    return this.builder.getState();
  }

  getOriginalUrl(): string {
    return this.getRouteState().originalUrl;
  }

  getPathname(): string {
    return this.getRouteState().pathname;
  }

  getParams(): RouteParams {
    return this.getRouteState().params;
  }

  private parse(url: string): void {
    const parsedUrl = urlModule.parse(url);

    if (parsedUrl.pathname) {
      this.parsePathname(parsedUrl.pathname);
    }
    if (parsedUrl.search) {
      this.parseSearch(parsedUrl.search);
    }
    if (parsedUrl.hash) {
      this.parseHash(parsedUrl.hash);
    }
  }

  private parsePathname(pathname: string): void {
    const paging = pathname.match(/\/p-([0-9]+)\/$/);

    if (paging) {
      pathname = pathname.slice(0, paging.index + 1);
      this.builder.setPage(paging[1]);
    }

    this.builder.setPathname(pathname);
  }

  private parseSearch(search: string): void {
    const queryString = qsModule.parse(search.slice(1));

    if ('q' in queryString && typeof queryString.q === 'string') {
      this.builder.setQuery(queryString.q);
    }
  }

  private parseHash(hash: string): void {
    hash = hash.slice(1);

    for (const param of hash.split('_')) {
      const [paramName, paramValue] = param.split('=');
      this.builder.set(paramName, decodeURIComponent(paramValue));
    }
  }
}
